import Parallax from "parallax-js";

export const initThumbnails = () => {
	setupParallaxOnThumbs();
};

const setupParallaxOnThumbs = () => {
	const thumbs = document.querySelectorAll(".thumbnail");

	thumbs.forEach((thumb) => {
		const parallaxScene = thumb.querySelector(".parallax-scene");
		if (!parallaxScene) return;

		let parallaxInstance; // Initialize the parallax instance later on hover

		thumb.addEventListener("mouseenter", () => {
			// Start the parallax effect on hover
			parallaxInstance = new Parallax(parallaxScene);
		});

		thumb.addEventListener("mouseleave", () => {
			// Disable parallax when mouse leaves
			if (parallaxInstance) {
				parallaxInstance.disable();
				parallaxInstance = null;
			}
		});
	});
};
